var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteMessageSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "35px",
    viewBox: "0 0 36 38",
    id: "svg36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs40"
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title22"
  }, "Icons/Pinpoint Map Copy 28") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title22"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "03-Rede-Medica_Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MY-D-03-06-01_ErroAPIPreco",
    transform: "translate(-854.000000, -1102.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MAP",
    transform: "translate(741.000000, 973.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Pinpoint-Map-Copy-28",
    transform: "translate(114.500000, 131.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5,28 L17.976431,33.5787722 C17.1993451,34.3637635 15.9330308,34.3700599 15.1481084,33.5929045 C15.1480852,33.5928815 15.148062,33.5928586 15.1481077,33.592766 L9.5,28 L9.5,28 L23.5,28 Z",
    id: "Arrow-Baixo",
    stroke: "#000000",
    strokeWidth: 2.5,
    fill: "#000000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Valor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,0 L27,0 C30.3137085,1.44626758e-15 33,2.6862915 33,6 L33,22.1911333 C33,25.5048418 30.3137085,28.1911333 27,28.1911333 L6,28.1911333 C2.6862915,28.1911333 -4.82366169e-16,25.5048418 0,22.1911333 L0,6 C-1.29399067e-15,2.6862915 2.6862915,-2.79460044e-16 6,0 Z",
    id: "Rectangle",
    stroke: "#000000",
    strokeWidth: 2.5,
    fill: "#FFFFFF",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.5,25 L17.9773179,31.5796509 C17.1997259,32.3641408 15.9334079,32.3696467 15.1489707,31.5920015 C15.148953,31.5919839 15.1489352,31.5919663 15.1489703,31.5918955 L8.5,25 L8.5,25 L24.5,25 Z",
    id: "Arrow-Cima",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteMessageSmall);
export default __webpack_public_path__ + "static/media/white_message_small.d742a899c4cda5b98bdeb9c6a0ddbd51.svg";
export { ForwardRef as ReactComponent };